
import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import cybersafety from './file/cybersafety.png';
import './style.css';

class Navigation extends Component {

    constructor(props) {
        super(props);

        this.state = {
            pageLanguage: "en",
        };
    }

    changeEnglishLanguage = (e) => {
        e.preventDefault();
        console.log('The language is English');
        this.setState({ pageLanguage: 'en' });
        var element = document.getElementById("greekLang");
        element.classList.remove("active");
        var element2 = document.getElementById("englishLang");
        element2.classList.add("active");
    };

    changeGreekLanguage = (e) => {
        e.preventDefault();
        console.log('The language is Greek');
        this.setState({ pageLanguage: 'gr' });
        var element = document.getElementById("englishLang");
        element.classList.remove("active");
        var element2 = document.getElementById("greekLang");
        element2.classList.add("active");
    };

    render() {
        let homeMenu = this.state.pageLanguage == 'en' ? "Home" : "Αρχικη";
        let aboutMenu = this.state.pageLanguage == 'en' ? "About" : "Σχετικα";
        let worksMenu = this.state.pageLanguage == 'en' ? "How it Works" : "Πως δουλευει";
        let tutorialMenu = this.state.pageLanguage == 'en' ? "User Manual" : "Οδηγιες Χρησης";
        let googleMenu = this.state.pageLanguage == 'en' ? "Google Play App Scanner" : "Αναλυση Εφαρμογης απο Google Play";
        let webMenu = this.state.pageLanguage == 'en' ? "URL Malware Scanner" : "Αναλυση Ιστοσελιδας";
        let contactMenu = this.state.pageLanguage == 'en' ? "Contact" : "Επικοινωνια";


        return (
            <div className="navigation" >
                <nav className="navbar navbar-expand-lg bg-secondary text-uppercase" id="mainNav">
                    <div className="container">
                        <a href="https://www.cybersafety.cy/"> <img src={cybersafety} alt="" className="euroPic" /></a>
                        <a className="nav-link py-3 px-0 px-lg-3 rounded js-scroll-trigger" href="#">PrivacySaferII</a>
                        <div>
                            <ul className="navbar-nav ml-auto">
                                <li className="nav-item mx-0 mx-lg-1">
                                    <NavLink className="nav-link py-3 px-0 px-lg-3 rounded js-scroll-trigger" to="/" >
                                        {homeMenu}
                                        <span className="sr-only">(current)</span>
                                    </NavLink>
                                </li>
                                <li className="nav-item mx-0 mx-lg-1">
                                    <NavLink className="nav-link py-3 px-0 px-lg-3 rounded js-scroll-trigger" to="/about">
                                        {aboutMenu}
                                    </NavLink>
                                </li>
                                <li className="nav-item mx-0 mx-lg-1">
                                    <NavLink className="nav-link py-3 px-0 px-lg-3 rounded js-scroll-trigger" to="/works">
                                        {worksMenu}
                                    </NavLink>
                                </li>
                                <li className="nav-item mx-0 mx-lg-1">
                                    <NavLink className="nav-link py-3 px-0 px-lg-3 rounded js-scroll-trigger" to={{ pathname: "/usermanual" }} state={{ from: this.state.pageLanguage }}>
                                        {tutorialMenu}
                                    </NavLink>
                                </li>
                                <li className="nav-item mx-0 mx-lg-1">
                                    <NavLink className="nav-link py-3 px-0 px-lg-3 rounded js-scroll-trigger" to="/contact">
                                        {contactMenu}
                                    </NavLink>
                                </li>
                                <li className="nav-item mx-0 mx-lg-1" >
                                    <a id="englishLang" className="nav-link py-3 px-0 px-lg-3 rounded js-scroll-trigger active"
                                        href="#" onClick={this.changeEnglishLanguage}>EN</a>
                                </li>
                                <li className="nav-item mx-0 mx-lg-1" >
                                    <a id="greekLang" className="nav-link py-3 px-0 px-lg-3 rounded js-scroll-trigger"
                                        href="#" onClick={this.changeGreekLanguage}>ΕΛ</a>
                                </li>

                            </ul>
                        </div>
                    </div>
                </nav >
            </div >
        );
    }
}

export default Navigation;